import { FC, useEffect, useState } from 'react';
import { MOBILE_REG } from '@lhb/regexp';
import { useMethods } from '@lhb/hook';
import { showInvalidFieldMsg } from '@/common/utils/ways';
import { postLogin } from '@/common/api/common';
import { ChangeModalStatus } from '../ts-config';

import styles from './index.module.less';
import { LockOutlined, MobileOutlined } from '@ant-design/icons';
import { Form, Button } from 'antd';
import V2Form from 'src/common/components/Form/V2Form/index';
import V2FormRadio from 'src/common/components/Form/V2FormRadio/V2FormRadio';
import V2FormInput from 'src/common/components/Form/V2FormInput/V2FormInput';
import GetCode from '@/common/components/GetCode';

// 是否本地开发环境
const isDevelopment = process.env.NODE_ENV === 'development';

// 手机验证码登录
const CodeLogin: FC<ChangeModalStatus> = ({ showChangeAccount }) => {

  const [requesting, setRequesting] = useState(false);

  const [form] = Form.useForm();

  // 常用手机号
  const mobileList = [
    { label: '张以恒', value: '13375700790' },
    { label: '王峙文', value: '18655246805' },
    { label: '刘亚俊', value: '15757107204' },
    { label: '顾云霄', value: '13957785093' },
    { label: '黄龚伟', value: '18755777113' },
    { label: '姜亮平', value: '13093783236' },
  ];

  useEffect(() => {

    // 仅在本地开发环境生效
    if (isDevelopment) {
      form.setFieldValue('code', '888888');
    }
  }, []);

  const methods = useMethods({
    // 信息填写完成填入cookie跳转到首页
    login() {
      console.log(form.getFieldsValue());
      if (requesting) {
        return;
      }
      form.validateFields().then((values: any) => {
        console.log('values', values);
        setRequesting(true);
        postLogin({ ...values }).then(({ token }) => {
          if (token) {
            showChangeAccount(true, token);
          }
        }).finally(() => {
          setRequesting(false);
        });
      }).catch((err) => {
        err && showInvalidFieldMsg(err.errorFields, 1);
      });
    },
  });

  return (
    <div className={styles.codeLogin}>
      <V2Form form={form} size='large' layout='horizontal'>
        {!!isDevelopment && <>
          <V2FormRadio name='mobile' label='快捷选择手机号' options={mobileList} onChange={() => form.validateFields(['mobile']) } />
        </>}
        <V2FormInput
          name='mobile'
          rules={[
            { required: true, message: '请输入手机号' },
            { pattern: MOBILE_REG, message: '手机号格式错误' },
          ]}
          maxLength={11}
          config={{ autoComplete: 'on' }}
          prefix={<MobileOutlined />}
          placeholder='请输入手机号'
        />
        <V2FormInput
          name='code'
          rules={[{ required: true, message: '请输入验证码' }]}
          placeholder='请输入验证码'
          maxLength={6}
          prefix={<LockOutlined />}
          config={{
            suffix: <GetCode form={form}/>,
            className: styles.inputStyle,
          }}
        />
        <Button type='primary' block disabled={requesting} className={styles.submitBtn} onClick={methods.login}>登录</Button>
      </V2Form>
    </div>
  );
};

export default CodeLogin;
